import { get } from 'lodash';
import { FOERDERPROGRAMM_ERKLAERUNG_UND_UNTERLAGEN_MA_PATHS } from 'src/lib/constants/componentsPath';
import { ANTRAGS_STATUS } from 'src/lib/constants/constant';
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
import MittelabrufSchema from 'src/lib/paths/mittelabruf_FULL_Paths.json';
import { getFieldNamefromDataPath, removeIdsFromArrayObjects } from './helper';

const P = AntragSchema.attributes;
const MA_P = MittelabrufSchema.attributes;

export const getMittelabrufeFromProjektJahr = (mittelabruf: any[], projektJahr: number) => {
	const mittelabrufeImProjektJahr = mittelabruf.filter(
		(eachMA: any) =>
			Number(get(eachMA, MA_P.Allgemein_Haushaltsjahr.path, 0)) === projektJahr &&
			get(eachMA, MA_P.Mittelabrufstatus_Mittelabrufstatus.path, '') !== ANTRAGS_STATUS.abgelehnt,
	);

	mittelabrufeImProjektJahr.sort((a: any, b: any) => {
		const createdAtA = new Date(get(a, 'createdAt', 0)).getTime();
		const createdAtB = new Date(get(b, 'createdAt', 0)).getTime();
		return createdAtA - createdAtB;
	});

	return mittelabrufeImProjektJahr;
};

export const getMittelabrufErklaerungenUndAnlagenData = (foerderprogramm: any) => {
	const paths = FOERDERPROGRAMM_ERKLAERUNG_UND_UNTERLAGEN_MA_PATHS;

	const pflichtErklaerungenAusProgramm = get(foerderprogramm, paths.PflichtErklaerungen, []);
	const optionaleErklaerungenAusProgramm = get(foerderprogramm, paths.OptionaleErklaerungen, []);
	const pflichtAnlagen = get(foerderprogramm, paths.PflichtAnlagen, []);
	const optionaleAnlagen = get(foerderprogramm, paths.OptionaleAnlagen, []);

	return {
		[getFieldNamefromDataPath(MA_P.Erklaerungen_Pflichterklaerungen.path)]: removeIdsFromArrayObjects(pflichtErklaerungenAusProgramm),
		[getFieldNamefromDataPath(MA_P.Erklaerungen_Optionale_Erklaerungen.path)]: removeIdsFromArrayObjects(optionaleErklaerungenAusProgramm),
		[getFieldNamefromDataPath(MA_P.Anlagen_Erforderliche_Anlagen.path)]: removeIdsFromArrayObjects(pflichtAnlagen),
		[getFieldNamefromDataPath(MA_P.Anlagen_Optionale_Anlagen.path)]: removeIdsFromArrayObjects(optionaleAnlagen),
		[getFieldNamefromDataPath(MA_P.Anlagen_Sonstige_Anlagen.path)]: [{ Bezeichnung_Des_Dokuments: '' }],
	};
};

export const getMittelabrufBankdatenFromLastMittelabrufOrAntrag = (application: any) => {
	const mittelabruf = get(application, P.Foerderantrag_Mittelabrufs.path, []);

	if (!Array.isArray(mittelabruf) || mittelabruf.length === 0) {
		return {
			[getFieldNamefromDataPath(MA_P.Bankverbindung_Bezeichnung_Des_Kontos.path)]: get(
				application,
				P.Antragstellende_Organisation_Bankverbindung_Bezeichnung.path,
			),
			[getFieldNamefromDataPath(MA_P.Bankverbindung_Geldinstitut.path)]: get(
				application,
				P.Antragstellende_Organisation_Bankverbindung_Geldinstitut.path,
			),
			[getFieldNamefromDataPath(MA_P.Bankverbindung_IBAN.path)]: get(application, P.Antragstellende_Organisation_Bankverbindung_IBAN.path),
			[getFieldNamefromDataPath(MA_P.Bankverbindung_Kontoinhaber.path)]: get(
				application,
				P.Antragstellende_Organisation_Bankverbindung_Kontoinhaber.path,
			),
			[getFieldNamefromDataPath(MA_P.Bankverbindung_BIC.path)]: get(application, P.Antragstellende_Organisation_Bankverbindung_BIC.path),
		};
	}

	const lastMittelabruf = mittelabruf.reduce((latest: any, current: any) => {
		const latestCreatedAt = new Date(get(latest, 'createdAt', 0)).getTime();
		const currentCreatedAt = new Date(get(current, 'createdAt', 0)).getTime();
		return currentCreatedAt > latestCreatedAt ? current : latest;
	});

	return {
		[getFieldNamefromDataPath(MA_P.Bankverbindung_Bezeichnung_Des_Kontos.path)]: get(
			lastMittelabruf,
			MA_P.Bankverbindung_Bezeichnung_Des_Kontos.path,
		),
		[getFieldNamefromDataPath(MA_P.Bankverbindung_Geldinstitut.path)]: get(lastMittelabruf, MA_P.Bankverbindung_Geldinstitut.path),
		[getFieldNamefromDataPath(MA_P.Bankverbindung_IBAN.path)]: get(lastMittelabruf, MA_P.Bankverbindung_IBAN.path),
		[getFieldNamefromDataPath(MA_P.Bankverbindung_Kontoinhaber.path)]: get(lastMittelabruf, MA_P.Bankverbindung_Kontoinhaber.path),
		[getFieldNamefromDataPath(MA_P.Bankverbindung_BIC.path)]: get(lastMittelabruf, MA_P.Bankverbindung_BIC.path),
	};
};

export const hasChangedMittelabrufBankdaten = (mittelabrufApplication: any) => {
	const selectedIban = get(mittelabrufApplication, MA_P.Bankverbindung_IBAN.path, '');
	const currentMittelabrufId = get(mittelabrufApplication, 'id');

	const allMittelabrufe = get(mittelabrufApplication, MA_P.Foerderantrag.schema.attributes.Foerderantrag_Mittelabrufs.path, []);
	const mittelabrufeOhneAktuellen =
		Array.isArray(allMittelabrufe) ? allMittelabrufe.filter((ma: any) => get(ma, 'id') !== currentMittelabrufId) : [];

	if (mittelabrufeOhneAktuellen.length === 0) {
		const antragIban = get(mittelabrufApplication, MA_P.Foerderantrag.schema.attributes.Antragstellende_Organisation_Bankverbindung_IBAN.path, '');
		return selectedIban !== antragIban;
	}

	const letzterMittelabruf = mittelabrufeOhneAktuellen.reduce((latest: any, current: any) => {
		const latestCreatedAt = new Date(get(latest, 'createdAt', 0)).getTime();
		const currentCreatedAt = new Date(get(current, 'createdAt', 0)).getTime();
		return currentCreatedAt > latestCreatedAt ? current : latest;
	});

	const letzterMittelabrufIban = get(letzterMittelabruf, MA_P.Bankverbindung_IBAN.path, '');
	return selectedIban !== letzterMittelabrufIban;
};
